import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { Empty, Image, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import geo from '../Res/geodan 8.svg'

function ViewImages(props: { data1: any[], data2: any[]  }) {
    const [index, setIndex] = useState(0)
    const [elements, setElement] = useState<any[]>([])
    //var elements : any = []

    useEffect(() => {
        //setIndex(0)
        if (props.data1.length != 0 && props.data1.length != 0) {
            var newData: any[] = []
            props.data1.map((d) => {
                newData.push((<>
                    <Tooltip title={d.type + ' - ' + d.nom + " " + d.prenom + ' - CNI : ' + d.cni}>
                        <Box fontStyle={"inherit"} display={"flex"}>
                            <Box display={"block"} fontStyle="inherit" className='border-left image'>
                                <legend >Photo</legend>
                                <Image src={d.photo} />
                                <br />
                            </Box>
                            <Box display={"block"} fontStyle="inherit" className='border-left image'>
                                <legend >Signature</legend>
                                <Image src={d.signature} />
                            </Box>
                        </Box>
                    </Tooltip>
                </>))
            })
            props.data2.map((d) => {
                newData.push((<>
                    <Tooltip title={d.type + ' - ' + d.nom + " " + d.prenom + ' - CNI : ' + d.cni}>
                        <Box fontStyle={"inherit"} display={"flex"}>
                            <Box display={"block"} fontStyle="inherit" className='border-left image'>
                                <legend >Photo</legend>
                                <Image width={"100%"} src={d.photo} />
                                <br />
                            </Box>
                            <Box display={"block"} fontStyle="inherit" className='border-left image'>
                                <legend >Signature</legend>
                                <Image width={"100%"} src={d.signature} />
                            </Box>
                        </Box>
                    </Tooltip>
                </>))
            })
            setElement(newData)
        }else{
            setElement([])
        }
    })

    function handleChange(sens: string) {
        if (sens == '+') {
            if (index + 1 < elements.length) {
                setIndex(index + 1)
            }
        }
        else {
            if (index > 0) {
                setIndex(index - 1)
            }
        }
    }

    return (
        <Box display={"flex"} className='border-left bordure1' fontStyle={"inherit"}>
            <Tooltip title='Prev'>
                <IconButton disabled={!(index > 0)} onClick={() => { handleChange('-') }} style={{ height: '35px', marginTop: '30%' }} size='small'><NavigateBefore /></IconButton>
            </Tooltip>
            {elements.length != 0 ? elements[index] : <Empty />}
            <Tooltip title='Next'>
                <IconButton disabled={!(index + 1 < elements.length)} onClick={() => { handleChange('+') }} style={{ height: '35px', marginTop: '30%' }} size='small'><NavigateNext /></IconButton>
            </Tooltip>
            {elements.length != 0 ? <Box borderColor={"lightgray"} border={.5} boxShadow={3} padding={.5} borderRadius={10} position={"absolute"}>{(index + 1) + "/" + elements.length}</Box> : ""}
        </Box>
    );
};

export default ViewImages;